import * as campaignTypes from './campaign.type';

const initialState = {
  campaignList: [],
  error: null,
  isLoading: false,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case `${campaignTypes.GET_CAMPAIGN_LIST_PENDING}`:
      return { ...state, isLoading: true, error: null };

    case `${campaignTypes.GET_CAMPAIGN_LIST_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        campaignList: payload.data,
      };

    case `${campaignTypes.GET_CAMPAIGN_LIST_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: payload,
        campaignList: [],
      };

    default:
      return state;
  }
};

export default reducer;
